import kosmosLogo from '../assets/kosmos-logo-white.png';
import {Link} from "react-router-dom";
import * as React from "react";
import {JSX} from "react";

type Social = {
    name: string;
    href: string;
    icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
};

const navigation = {
    news: [
        {name: 'Jongste Nuus', to: '/nuus'},
        {name: 'Kategorieë', to: '/nuus/kategorieë'},
        {name: 'Luister Nuus', to: '/nuus/luister'},
        {name: 'Op Die Kantlyn', to: '/nuus/op-die-kantlyn'},
        {name: 'Op’ie Lug', to: '/nuus/op-die-lug'},
    ],
    other: [
        {name: 'Kompetisies', to: '/kompetisies'},
        {name: 'Aanbieders', to: '/op-die-lug/aanbieders'},
        {name: 'Programme', to: '/op-die-lug/programme'},
        {name: 'Gesprekke', to: '/potgooi/gesprekke'},
        {name: 'Gedagte vir die dag', to: '/potgooi/gedagte-vir-die-dag'},
    ],
    company: [{name: 'About', to: '/about'}],
    legal: [
        {name: 'Kompetisies Terms and Conditions', to: '/kompetisies-ts-and-cs'},
        {name: 'Privacy Policy', to: '/privacy-policy'},
    ],
    social: [
        {
            name: 'Facebook',
            href: 'https://www.facebook.com/Kosmos94.1',
            icon: (props: React.SVGProps<SVGSVGElement>) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'Instagram',
            href: 'https://www.instagram.com/kosmos94.1',
            icon: (props: React.SVGProps<SVGSVGElement>) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.49 1.791.218 2.427.465a4.9 4.9 0 011.772 1.153A4.9 4.9 0 0121.475 5.45c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'X',
            href: 'https://x.com/Kosmos941',
            icon: (props: React.SVGProps<SVGSVGElement>) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z"/>
                </svg>
            ),
        },
        {
            name: 'YouTube',
            href: 'https://www.youtube.com/@kosmos94.1',
            icon: (props: React.SVGProps<SVGSVGElement>) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
    ] as Social[],
};

export default function Footer() {
    return (
        <footer className="bg-gray-800">
            <div className="mx-auto max-w-7xl px-6 pt-16 pb-8 sm:pt-24 lg:px-8 lg:pt-32">
                <div className="xl:grid xl:grid-cols-3 xl:gap-8">
                    <div className="space-y-8">
                        <Link to="/" className="inline-flex items-center">
                            <img src={kosmosLogo} alt="Kosmos 94.1 Logo" className="h-10 w-auto"/>
                            <span className="sr-only">Kosmos 94.1</span>
                        </Link>
                        <p className="text-sm/6 text-balance text-gray-400">
                            Kosmos 94.1 is Namibië se gunsteling Afrikaanse radiostasie.
                        </p>
                        <div className="flex gap-x-6">
                            {navigation.social.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-400 hover:text-gray-300"
                                >
                                    <span className="sr-only">{item.name}</span>
                                    <item.icon aria-hidden="true" className="size-6"/>
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
                        <div className="md:grid md:grid-cols-2 md:gap-8">
                            <div>
                                <h3 className="text-sm/6 font-semibold text-white">Nuus</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    {navigation.news.map((item) => (
                                        <li key={item.name}>
                                            <Link
                                                to={item.to}
                                                className="text-sm/6 text-gray-400 hover:text-gray-300"
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="mt-10 md:mt-0">
                                <h3 className="text-sm/6 font-semibold text-white">Bladsye</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    {navigation.other.map((item) => (
                                        <li key={item.name}>
                                            <Link
                                                to={item.to}
                                                className="text-sm/6 text-gray-400 hover:text-gray-300"
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="md:grid md:grid-cols-2 md:gap-8">
                            {/*<div>*/}
                            {/*    <h3 className="text-sm/6 font-semibold text-white">Company</h3>*/}
                            {/*    <ul role="list" className="mt-6 space-y-4">*/}
                            {/*        {navigation.company.map((item) => (*/}
                            {/*            <li key={item.name}>*/}
                            {/*                <Link*/}
                            {/*                    to={item.to}*/}
                            {/*                    className="text-sm/6 text-gray-400 hover:text-gray-300"*/}
                            {/*                >*/}
                            {/*                    {item.name}*/}
                            {/*                </Link>*/}
                            {/*            </li>*/}
                            {/*        ))}*/}
                            {/*    </ul>*/}
                            {/*</div>*/}

                            <div className="mt-10 md:mt-0">
                                <h3 className="text-sm/6 font-semibold text-white">Legal</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    {navigation.legal.map((item) => (
                                        <li key={item.name}>
                                            <Link
                                                to={item.to}
                                                className="text-sm/6 text-gray-400 hover:text-gray-300"
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24 flex justify-between">
                    <p className="text-sm/6 text-gray-400">
                        &copy; {new Date().getFullYear()} Kosmos 94.1. All rights reserved.
                    </p>
                    {/*<p className="text-sm/6 text-gray-400">*/}
                    {/*    Created by{" "}*/}
                    {/*    <a*/}
                    {/*        href="https://pct-ventures.com"*/}
                    {/*        target="_blank"*/}
                    {/*        rel="noopener noreferrer"*/}
                    {/*        className="text-gray-300 hover:text-gray-200"*/}
                    {/*    >*/}
                    {/*        PCT Ventures &#x2197;*/}
                    {/*    </a>*/}
                    {/*</p>*/}
                </div>
            </div>
        </footer>
    );
}
